import React from "react";
import PropTypes from "prop-types";
import MultiStyleButton from "../../../../systemUtils/MultiStyleButton";

const UserStep1Intro = ({ setCardStep }) => {
  return (
    <>
      <h1 className="card-title step1-title">User System Permissions</h1>
      <p className="card-subtitle step1-subtitle">
        Manage who can add new users, revoke user access, restore user access,
        and delete users
      </p>
      <div className="continue-button-container">
        <MultiStyleButton
          label="Continue"
          buttonType="approve"
          onClick={() => setCardStep(2)}
        />
      </div>
    </>
  );
};

UserStep1Intro.propTypes = {
  setCardStep: PropTypes.func.isRequired,
};

export default UserStep1Intro;
